@if(!isLoading()){
    <div class="banner">
        <div class="banner-content">
            <img class="banner-image" [src]="elementVariables().banner_desktop | bucket" [fallback]="'/old/friends/refer_a_friend_banner.webp'" alt='Invite a Friend' draggable="false">
            <img class="banner-image-sm" [src]="elementVariables().banner_mobile | bucket" [fallback]="'/old/friends/refer_a_friend_banner_sm.webp'" alt='Invite a Friend' draggable="false"/>
        </div>
    </div>
    <div class="below-banner">
        <div class="code-box">
            {{virtualCode() ? 'Code: ' + virtualCode() : 'Oops, an error has occurred! Please try again.'}}
        </div>
        @if(elementVariables().how_to_play_popup_image){
            <div id="howToPlay" (click)="openHowTo()">
                <span class="font-bold">How to Play</span>
            </div>
        }
        <div class="button-group">
            <p>Don't have the cloudigo app?</p>
            <a [routerLink]="['/builder']" [queryParams]="queryParams" target="_blank" mat-raised-button class="font-semibold" (click)="copyAndGo(virtualCode())">
                <span>DOWNLOAD CLOUDIGO</span>
            </a>
            <a mat-raised-button class="font-semibold" (click)="copyAndGo(virtualCode())">
                <span>{{virtualCode() ? 'COPY CODE & ' : '' }}PLAY</span>
            </a>
        </div>
    </div>
} @else {
    <div class="svg-loader">
        <object data="old/cloudigo_loader.svg" type="image/svg+xml"></object>
    </div>
}

<ng-template #howToImg>
    <!-- <div class="ht-popup-header"> -->
    <!-- </div> -->
    <div class="img-container">
        <button mat-icon-button color="warn" [mat-dialog-close]><mat-icon>close</mat-icon></button>
        <img  draggable="false" [src]="elementVariables().how_to_play_popup_image | bucket" alt='How To Play'>
    </div>
</ng-template>